import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { useEffect } from 'react';
import { logger } from 'services/logger/logger';
import { cookies } from 'utils/cookies/cookies';

type NotFoundSource = 'not_found' | 'fallback' | 'default_fallback';

const useNotFoundLogger = (
  search: string,
  pathname: string,
  source: NotFoundSource,
  error?: Error,
  componentStack?: string | null,
) => {
  useEffect(() => {
    const referrer = document.referrer;

    let searchDecodable = true;
    try {
      decodeURIComponent(search);
    } catch {
      searchDecodable = false;
    }

    const peerTrackerId = cookies.read(PERMANENT_COOKIE_NAME);

    let translationDiagnostics = {
      browser_language: null as string | null,
      browser_languages: null as string | null,
      dom_translated: null as boolean | null,
      translate_font_node_count: null as number | null,
      html_lang_attr: null as string | null,
      user_agent: null as string | null,
    };
    try {
      translationDiagnostics = {
        browser_language: navigator.language,
        browser_languages: navigator.languages.join(','),
        dom_translated:
          document.documentElement.classList.contains('translated-ltr') ||
          document.documentElement.classList.contains('translated-rtl'),
        translate_font_node_count:
          document.querySelectorAll('font[_msttexthash]').length,
        html_lang_attr: document.documentElement.lang || null,
        user_agent: navigator.userAgent,
      };
    } catch {
      // diagnostic collection failed — keep nulls
    }

    logger.log({
      description: 'not_found_page_rendered',
      parameters: {
        pathname: `${pathname}${search}`,
        search_decodable: searchDecodable,
        search_length: search.length,
        referrer,
        source,
        peer_tracker_id: peerTrackerId || null,
        error_message: error?.message ?? null,
        error_name: error?.name ?? null,
        error_stack: error?.stack ?? null,
        component_stack: componentStack ?? null,
        ...translationDiagnostics,
      },
    });
  }, [
    search,
    pathname,
    error?.message,
    source,
    error?.stack,
    error?.name,
    componentStack,
  ]);
};

export { useNotFoundLogger };
